import { useEffect, useState, useRef, createRef } from "react";

import useSound from "use-sound";
import {
  ImArrowUp,
  ImArrowRight,
  ImArrowDown,
  ImArrowLeft,
} from "react-icons/im";
import ArrowButtons from "./arrowButtons";

export default function Level5_LetterCharts(props) {
  var [grid, setGrid] = useState(3);
  var [chart, setChart] = useState([]);
  var [beat, setBeat] = useState(1000);
  var [sound, setSound] = useState(false);
  var [fontCase, setFontCase] = useState("lowercase");
  var [mode, setMode] = useState("Off");
  var [size, setSize] = useState("36pt");
  var [spacing, setSpacing] = useState("0px");
  var [intervalId, setIntervalId] = useState(0);
  var alph = "abcdefghijklmnopqrstuvwxyz";
  var selected = [];
  var place = 0;
  var [testTime, setTestTime] = useState(0);
  var [running, setRunning] = useState(false);
  var curr = 0;
  var [start, setStart] = useState(true);

  function preLoadImages() {
    for (let i = 0; i < 4; i++) {
      if (i === 0) {
        for (let i = 1; i < 6; i++) {
          createImage("/Coding/HalopinHands6/" + JSON.stringify(i) + "BBL.png");
          createImage("/Coding/HalopinHands6/" + JSON.stringify(i) + "BBR.png");
        }
      }
      if (i === 1) {
        for (let i = 1; i < 6; i++) {
          createImage("/Coding/HalopinHands6/" + JSON.stringify(i) + "BPL.png");
          createImage("/Coding/HalopinHands6/" + JSON.stringify(i) + "BPR.png");
        }
      }
      if (i === 2) {
        for (let i = 1; i < 6; i++) {
          createImage("/Coding/HalopinHands6/" + JSON.stringify(i) + "BOL.png");
          createImage("/Coding/HalopinHands6/" + JSON.stringify(i) + "BOR.png");
        }
      }
      if (i === 3) {
        for (let i = 1; i < 6; i++) {
          createImage("/Coding/HalopinHands6/" + JSON.stringify(i) + "BYL.png");
          createImage("/Coding/HalopinHands6/" + JSON.stringify(i) + "BYR.png");
        }
      }
    }
  }

  function createImage(image) {
    const img = new Image();
    img.src = image;
  }

  const [play] = useSound("/clickSound.wav");

  const [flash, setFlash] = useState(false);

  const myRefs = useRef([]);

  const chartRef = useRef();

  useEffect(() => {
    preLoadImages();
  }, []);

  useEffect(() => {
    if (intervalId) {
      stopFunction();
      setChart([]);
      clearTimeout(testTime);
      setRunning(false);
    }
    if (mode === "Off") {
      setChart([]);
    }
    setStart(true);
  }, [grid, fontCase, size, mode, spacing, beat, sound]);

  useEffect(() => {
    var highestTimeoutId = setTimeout(";");
    for (var i = 0; i < highestTimeoutId; i++) {
      clearTimeout(i);
      clearInterval(i);
    }
  }, [props.change, sound, beat, grid]);

  function stopFunction() {
    clearInterval(intervalId);
    setIntervalId(0);
  }

  function selectedLetters() {
    let count = parseInt(grid) * parseInt(grid);
    for (let i = 0; i < count; i++) {
      selected.push(i);
    }
  }

  function clearOut(index) {
    let test = setTimeout(() => {
      myRefs.current[index].current.style.color = "white";
    }, 500);
    setTestTime(test);
  }

  function triggerGreen() {
    setRunning(true);
    var color = setInterval(() => {
      if (sound) {
        play();
      }
      myRefs.current[place].current.style.color = "greenyellow";
      clearOut(place);
      place++;
      if (place === parseInt(grid) * parseInt(grid)) {
        clearInterval(color);
        setRunning(false);
      }
    }, beat);
    setIntervalId(color);
  }

  function reset() {
    setChart([]);
    chartRef.current.style.visibility = "hidden";
    if (running) {
      clearInterval(intervalId);
      clearInterval(testTime);
      setRunning(false);
    }
    setTimeout(() => {
      createRow();
      setTimeout(() => {
        chartRef.current.style.visibility = "visible";
      }, 450);
    }, 50);
  }

  function getDirection() {
    let direction = Math.floor(Math.random() * 4) + 1;
    if (direction === 1) {
      let number = JSON.stringify(Math.floor(Math.random() * 5) + 1);
      if (Math.random() > 0.5) {
        return (
          <img
            src={"/Coding/HalopinHands6/" + number + "BBL.png"}
            height="80px"
            width="66px"
          />
        );
      }
      return (
        <img
          src={"/Coding/HalopinHands6/" + number + "BBR.png"}
          height="80px"
          width="66px"
        />
      );
    }
    if (direction === 2) {
      let number = JSON.stringify(Math.floor(Math.random() * 5) + 1);
      if (Math.random() > 0.5) {
        return (
          <img
            src={"/Coding/HalopinHands6/" + number + "BOL.png"}
            height="80px"
            width="66px"
          />
        );
      }
      return (
        <img
          src={"/Coding/HalopinHands6/" + number + "BOR.png"}
          height="80px"
          width="66px"
        />
      );
    }
    if (direction === 3) {
      let number = JSON.stringify(Math.floor(Math.random() * 5) + 1);
      if (Math.random() > 0.5) {
        return (
          <img
            src={"/Coding/HalopinHands6/" + number + "BYL.png"}
            height="80px"
            width="66px"
          />
        );
      }
      return (
        <img
          src={"/Coding/HalopinHands6/" + number + "BYR.png"}
          height="80px"
          width="66px"
        />
      );
    }
    if (direction === 4) {
      let number = JSON.stringify(Math.floor(Math.random() * 5) + 1);
      if (Math.random() > 0.5) {
        return (
          <img
            src={"/Coding/HalopinHands6/" + number + "BPL.png"}
            height="80px"
            width="66px"
          />
        );
      }
      return (
        <img
          src={"/Coding/HalopinHands6/" + number + "BPR.png"}
          height="80px"
          width="66px"
        />
      );
    }
  }

  function CreateLetters(place) {
    let temp = [];
    for (let i = 0; i < grid; i++) {
      temp.push(
        <div
          ref={myRefs.current[curr]}
          key={Date.now() + i}
          className="cellArrow"
          style={{ marginRight: spacing }}
        >
          {getDirection()}
        </div>,
      );
      curr++;
    }

    return temp;
  }

  function createRow() {
    curr = 0;
    selectedLetters();
    myRefs.current = selected.map(
      (element, i) => myRefs.current[i] ?? createRef(),
    );
    let tempChart = [];
    for (let i = 0; i < grid; i++) {
      tempChart.push(
        <div
          key={i}
          className="rowChart"
          style={{
            textTransform: fontCase,
            fontSize: size,
            textAlign: "center",
          }}
        >
          {CreateLetters(i)}
        </div>,
      );
    }
    setChart(tempChart);

    // triggerGreen();
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <div className="activitySettingsButtonsContainer">
        <ArrowButtons
          flashRate={setBeat}
          flashBool={beat}
          ChangeRow={setGrid}
          rowBool={grid}
          changeSound={setSound}
          soundBool={sound}
          changeFlash={setFlash}
          FlashRateDisplay="none"
        />
      </div>
      {props.open && (
        <div style={{ margin: "auto" }} ref={chartRef}>
          {chart}
        </div>
      )}
      <div className="activityActionButtonsContainer">
        <button
          className="activityActionButton"
          onClick={() => {
            if (props.open) {
              reset();
              setStart(false);
            } else {
              props.openActivity(true);
            }
          }}
        >
          Next
        </button>
      </div>
    </div>
  );
}
